import React from "react";
import { useTranslation } from "react-i18next";

import { PeriodStatus } from "../../../../services/AdminTransparencyService";

import style from "./styles.module.scss";

interface Props {
  status: PeriodStatus;
}

export default function StatusTag({ status }: Props) {
  const { t } = useTranslation();
  const published = status === "published";

  return (
    <span className={`pgm-label-large ${style.tag} ${published ? style.tagPublished : style.tagDraft}`}>
      <span aria-hidden="true" className={style.tagDot} />
      {t(`translations.admin.transparency.status.${published ? "published" : "draft"}`)}
    </span>
  );
}
